import ApiProjects from "../../api/projects";
import store from "..";
import { setProjectList, setCurrentProject, loadProjectFromStorage } from "../slices/projects";

export const bootstrapProjects = () => async (dispatch) => {
  const res = await ApiProjects.getMine();
  const list = res.data && res.data.projects ? res.data.projects : [];
  dispatch(setProjectList(list));
  dispatch(loadProjectFromStorage());

  const state = store.getState();
  const fromLS = state.projects.current && list.find(p => p.id === state.projects.current.id);

  let cur = fromLS
    || list.find(p => p.isDefault)
    || [...list].sort((a, b) => a.title.localeCompare(b.title))[0]
    || null;

  dispatch(setCurrentProject(cur));
};